import React, { Component } from "react";
import PropTypes from "prop-types";

class Timer extends Component {
  mounted = false;

  constructor(props) {
    super(props);
    this.state = {
      time: 0,
    };
  }

  componentDidMount() {
    this.mounted = true;
    this.manageCounter();
  }

  componentWillUnmount() {
    clearInterval(this.state.counter);
    this.mounted = false;
  }

  componentDidUpdate() {
    if (this.state.from !== this.props.from) {
      this.manageCounter();
    }
  }

  manageCounter() {
    // Start counter
    if (!this.state.counter && this.props.from !== 0 && !this.props.freeze) {
      var c = setInterval(() => {
        if (this.mounted) {
          this.setState({
            time: Date.now() - this.props.from,
          });
        }
      }, 1000);
      if (this.mounted) {
        this.setState({ counter: c });
      }
    }
    // Freeze counter
    else if (this.state.counter && this.props.freeze) {
      clearInterval(this.state.counter);
      if (this.mounted) {
        this.setState({
          counter: null,
        });
      }
    }
    // Stop counter and clear
    else if (this.props.from === 0 && this.state.time !== 0) {
      if (this.mounted) {
        this.setState({
          time: 0,
        });
      }
    }
  }

  render() {
    if (!this.state.time || (this.state.time === 0 && !this.state.counter)) {
      return null;
    }

    return (
      <span className="text-54">
        {new Date(this.state.time).toLocaleTimeString("en-EN", {
          minute: "2-digit",
          second: "2-digit",
        })}
      </span>
    );
  }
}

Timer.propTypes = {
  from: PropTypes.number.isRequired,
};

export default Timer;
